import { Emitter, Event } from '@theia/core/lib/common';
import { injectable } from '@theia/core/shared/inversify';
import {
    ProjectServiceEvent,
    type ITheiaProjectServiceClient,
    type ProjectServiceMessageBoxOptions
} from './project-service-protocol';

type ProjectServiceMessageBoxHandler = (options: ProjectServiceMessageBoxOptions) => Promise<number>;

@injectable()
export class TheiaProjectServiceWatcher {
    private action: Emitter<ProjectServiceEvent> = new Emitter<ProjectServiceEvent>();
    private messageBoxHandler: ProjectServiceMessageBoxHandler | undefined;

    getTheiaProjectServiceClient(): ITheiaProjectServiceClient {
        return {
            onProjectServiceEvent: (event: ProjectServiceEvent) => {
                this.action.fire(event);
            },
            showProjectServiceMessageBox: async (options: ProjectServiceMessageBoxOptions) => {
                if (this.messageBoxHandler) return this.messageBoxHandler(options);
                return options.cancelId ?? options.defaultId ?? options.buttons.length - 1;
            }
        };
    }

    setProjectServiceMessageBoxHandler(handler: ProjectServiceMessageBoxHandler | undefined): void {
        this.messageBoxHandler = handler;
    }

    get onProjectServiceEvent(): Event<ProjectServiceEvent> {
        return this.action.event;
    }
}
